import { render, staticRenderFns } from "./SysProcessDetail.vue?vue&type=template&id=8ef5334c&scoped=true"
import script from "./SysProcessDetail.vue?vue&type=script&lang=js"
export * from "./SysProcessDetail.vue?vue&type=script&lang=js"
import style0 from "./SysProcessDetail.vue?vue&type=style&index=0&id=8ef5334c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ef5334c",
  null
  
)

export default component.exports